/** 
 * Gets a DOM element from the HTML document. 
 * @param {string|HTMLElement} target - The accessibility text or element to select. 
 * @param {boolean} removeChildren - Whether to remove all content from the selected element. 
 * @returns {HTMLElement|undefined} The selected DOM element, or undefined if it doesn't exist. 
 */  
export default function get_dom_element(target, removeChildren) {
  let parentEl;
  let el;

  // Get DOM element
  if (typeof target == 'string') {
    const parentElString = "[data-acc-text='" + target + "']";
    parentEl = document.querySelector(parentElString);
    if (parentEl && parentEl.children.length) {
      el = parentEl.children[0];
      if (removeChildren) {
        el.textContent = ''; // Remove all content from element
      }
    } else {
      el = document.querySelector('#' + target);
    }
  } else if (target) {
    el = target;
  } else {
    console.log('No element or accessibility text provided. Returning.');
    return;
  }

  // Check if element exists
  if (!el) {
    console.log('No element found. Returning.');
    return;
  }

  // Return DOM element
  return el;
}
